import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="max-w-5xl mx-auto px-6 py-12 text-gray-800">
      <h1 className="text-3xl font-bold mb-6 text-gray-900">
        Privacy Policy
      </h1>

      <p className="mb-6">
        Paingoriya & Associates, Chartered Accountants, respects your privacy and
        is committed to safeguarding the confidentiality of personal, financial,
        and statutory information shared with us in the course of providing
        professional services.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        1. Data Collection
      </h2>
      <p className="mb-4">
        We may collect personal and professional information including name,
        address, email, phone number, PAN, GST details, financial records, and
        other statutory or business-related data as required for audit,
        taxation, compliance, advisory, and consultancy services.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        2. Data Usage
      </h2>
      <p className="mb-4">
        The information collected is used solely for lawful and professional
        purposes such as providing chartered accountancy services, preparation
        and filing of statutory returns, regulatory compliance, client
        communication, and internal record maintenance.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        3. Data Protection
      </h2>
      <p className="mb-4">
        We follow reasonable administrative, technical, and physical security
        practices to protect client data from unauthorized access, alteration,
        disclosure, or misuse. Access to information is restricted to authorized
        personnel only.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        4. Third Parties
      </h2>
      <p className="mb-4">
        We do not sell, rent, or trade client information to third parties. Data
        may be shared only where required by law, regulatory authorities, or
        professional obligations, and strictly on a need-to-know basis.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        5. Contact
      </h2>
      <p>
        For any privacy-related queries or concerns, you may contact us at{" "}
        <a
          href="mailto:paingoriyaandassociates@gmail.com"
          className="text-emerald-600 underline"
        >
          paingoriyaandassociates@gmail.com
        </a>
        .
      </p>
    </div>
  );
};

export default PrivacyPolicy;
